<template lang="pug">
.audience-edition
    .info-container
        .audience-edition-title Edit audience
        .audience-edition-label.is-truncate(
            :title="name"
        ) {{ name }}
    
    .logout-icon.l-flex-row(@click="exitEditAudience()")
        .audience-edition-exit Exit
        svg-icon.cursor(
            name="close",
            size="medium",
            title="exit edit audience"
        )

</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'FormulaEditionBox',

    props: {
        formula: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters('builder', ['audienceInEdition']),

        name() {
            return `${this.audienceInEdition?.id} - ${this.audienceInEdition.label}`
        }
    },

    methods: {
        ...mapMutations('builder', ['setAudienceInEditionId', 'setFormula']),

        exitEditAudience() {
            this.setAudienceInEditionId(undefined)
            this.formula.initializeFormula()
            this.formula.setRecency(30)
            this.formula.setQuantile(10)
            this.formula.setSurfIntensity(0)
            this.setFormula(this.formula)
        }
    }
}
</script>
